"use client"

import Link from "next/link"
import { config } from "@/config"
import { Code } from "lucide-react"
import { motion } from "motion/react"

import { cn } from "@/lib/utils"
import { useMounted } from "@/hooks/use-mounted"
import { useScrollDirection } from "@/hooks/use-scroll-direction"
import { ThemeToggle } from "@/components/theme-toggle"

export function Header() {
  const isMounted = useMounted()
  const { scrollDirection, isAtTop } = useScrollDirection()

  const shouldShowNavbar =
    isAtTop || scrollDirection === "up" || scrollDirection === null

  return (
    <motion.nav
      initial={{ y: 0 }}
      animate={{
        y: shouldShowNavbar ? 0 : -100,
      }}
      transition={{
        duration: 0.3,
        ease: "easeInOut",
      }}
      className={cn(
        "bg-background/95 supports-backdrop-filter:bg-background/60 sticky top-0 z-50 w-full backdrop-blur",
        isMounted && !isAtTop && "border-b"
      )}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-0">
        <Link
          href="/"
          className="flex min-w-0 items-center gap-2 transition-opacity hover:opacity-80"
        >
          <div className="bg-primary text-primary-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-bold">
            <Code className="h-4 w-4" />
          </div>
          <h1 className="truncate text-base font-bold tracking-tight sm:text-xl">
            {config.name}
          </h1>
        </Link>
        <div className="flex items-center gap-2">
          <ThemeToggle />
        </div>
      </div>
    </motion.nav>
  )
}
